import { render, staticRenderFns } from "./shopcart.vue?vue&type=template&id=6a50c047&lang=html&"
import script from "./shopcart.vue?vue&type=script&lang=js&"
export * from "./shopcart.vue?vue&type=script&lang=js&"
import style0 from "./shopcart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports